export default __webpack_public_path__ + "static/media/logo.1fb1db07.svg";